var angular = require('angular');
var moment = require('moment');

moment.updateLocale('en', {
  relativeTime : {
    future: "%s left",
    past:   "%s ago",
    s:  "seconds",
    m:  "a minute",
    mm: "%d minutes",
    h:  "an hour",
    hh: "%d hours",
    d:  "a day",
    dd: "%d days",
    M:  "a month",
    MM: "%d months",
    y:  "a year",
    yy: "%d years"
  }
});


var module =  angular.module("app.directives");



module.filter('forceDate', function(){
  return function(input){
    if (!input) return "";
    return moment.utc(input.slice(0, 10), 'YYYY-MM-DD');
  }
})


function parse(input){
  if (moment.isMoment(input)) return input;
  if (input.length > 10 && input.slice(-1) != "Z") {
    input += "Z";
  }
  return input;
}

module.filter('parseDate', function(){
  return function(input){
    return parse(input);
  }
})


module.filter('friendlyTimeLeft', function(){
  return function(input){
    if (!input) return "";
    return moment(parse(input)).fromNow();
  }
})

module.filter('friendlyDate', function(){
  return function(input){
    if (!input) return "";
    return moment(parse(input)).format('Do MMMM YYYY');
  }
})

module.filter('friendlyTime', function(){
  return function(input){
    if (!input) return "";
    return moment(parse(input)).format('h:mm a');
  }
})

module.filter('friendlyDateTime', function(){
  return function(input){
    if (!input) return "";
    return moment(parse(input)).format('Do MMM YYYY - h:mm a');
  }
})
